import React from 'react'
import { useRecoilState } from 'recoil'
import { IntlProvider } from 'react-intl'
import { localeSelector } from '../state/localeState'

import messages from '../i18n/messages.json'

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/locale-data/de') // Add locale data for de
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/locale-data/de') // Add locale data for de
}

const Locale = ({ children }) => {
  const [locale] = useRecoilState(localeSelector)

  return (
    <IntlProvider messages={messages[locale]} locale={locale} key={locale}>
      {children}
    </IntlProvider>
  )
}

export default Locale
